import React, { Component } from "react";
import { withRouter } from "react-router-dom";

import LoginForm from "./Form";

import Auth from "../../Auth";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      loading: false,
      loginFailed: false
    };
  }

  onChange = e => {
    const state = this.state;
    state[e.target.name] = e.target.value;
    this.setState(state);
  };

  onSubmit = e => {
    e.preventDefault();
    const { username, password } = this.state;

    this.setState({ loading: true, loginFailed: false });

    Auth.login(username, password, loggedIn => {
      if (!loggedIn) {
        return this.setState({
          username: "",
          password: "",
          loading: false,
          loginFailed: true
        });
      }

      this.props.history.push("/");
    });
  };

  render() {
    const { username, password, loading, loginFailed } = this.state;

    return (
      <LoginForm
        username={username}
        password={password}
        loading={loading}
        loginFailed={loginFailed}
        onChange={this.onChange}
        onSubmit={this.onSubmit}
      />
    );
  }
}

export default withRouter(Login);



// WEBPACK FOOTER //
// ./src/pages/Login/index.jsx